<template>
  <div class="podcast-actions container-fluid">
    <ul class="podcast-breadcrumbs flex">
      <li class="breadcrumb-item">Le mie storie</li>
      <li class="breadcrumb-item">
        <span class="separator">
          <ChevronRight />
        </span>
        <strong>{{ podcast.name }}</strong>
      </li>
    </ul>

    <ul class="actions flex">
      <li class="action-item">
        <button
          type="button"
          :disabled="!canSave || actionsLoading || updateLoading"
          class="btn-secondary relative"
          @click="$emit('save')"
        >
          <IconLoader v-if="updateLoading" class="save-icon" />
          <IconCheck v-if="showSaveTick" class="save-icon text-success" />
          Salva
        </button>
      </li>
      <li class="action-item">
        <a
          :href="`/${$route.params.tenant}/preview/${podcast._id}`"
          class="btn-secondary"
          target="_blank"
        >
          Preview
        </a>
      </li>
      <li class="action-item">
        <button
          type="button"
          class="btn-secondary"
          @click="$emit('delete')"
          :disabled="actionsLoading"
        >
          Cancella
        </button>
      </li>
      <li class="action-item">
        <router-link
          :to="{
            name: 'PodcastsSection',
            params: {
              id: podcast._id,
              section: 'export',
              tenant: $route.params.tenant,
            },
          }"
          class="podcast-nav-link"
        >
          <button type="button" class="btn-primary">
            Pubblica
          </button>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import ChevronRight from '@/assets/icons/icon-chevron_right.svg'
import IconLoader from '@/assets/icons/icon-loader.svg'
import IconCheck from '@/assets/icons/icon-check.svg'

export default {
  components: {
    ChevronRight,
    IconLoader,
    IconCheck,
  },

  props: {
    podcast: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showSaveTick: false,
      saveTickTimer: null,
    }
  },

  computed: {
    canSave() {
      return this.$store.state.podcast.dirty
    },
    actionsLoading() {
      return this.$store.state.podcast.actionsLoading
    },
    updateLoading() {
      return this.$store.state.podcast.updateLoading
    },
  },

  watch: {
    updateLoading(newValue) {
      if (this.saveTickTimer) {
        clearTimeout(this.saveTickTimer)
      }

      if (!newValue) {
        this.showSaveTick = true
        this.saveTickTimer = setTimeout(() => {
          this.showSaveTick = false
        }, 2000)
      } else {
        this.showSaveTick = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.podcast-actions {
  @apply py-8 flex items-center justify-between;

  .podcast-breadcrumbs {
    @apply flex;

    .breadcrumb-item {
      @apply text-xl font-sans pr-3;

      .separator {
        @apply inline-block w-8 pr-3 align-middle;
      }
    }
  }

  .actions {
    @apply flex;

    .action-item {
      @apply ml-2;

      .save-icon {
        @apply absolute w-3 h-3;
        left: 12px;
        top: 22px;
      }
    }
  }
}
</style>
